import React from 'react';
import { View, TouchableOpacity, StyleSheet } from 'react-native';
import CCText from '@/Atoms/CCText';
import CCColors from '@/Utils/CCColors';
import { FontSizes } from '@/Utils/Dimensions';
import { MaterialCommunityIcons } from '@expo/vector-icons';

interface ClassroomTestBannerProps {
  name: string;
  onOpen: () => void;
  onClose: () => void;
}

export default function ClassroomTestBanner({
  name,
  onOpen,
  onClose,
}: ClassroomTestBannerProps) {
  return (
    <View style={styles.banner}>
      <MaterialCommunityIcons
        name="clipboard-text-outline"
        size={20}
        color={CCColors?.White}
      />
      <View style={styles.textCol}>
        <CCText
          fontSize={FontSizes[14]}
          fontWeight={600}
          color={CCColors?.White}>
          Classroom test: {name}
        </CCText>
        <CCText fontSize={FontSizes[12]} color={CCColors?.White}>
          Opens in a new window
        </CCText>
      </View>
      <TouchableOpacity onPress={onOpen} style={styles.openBtn}>
        <CCText
          fontSize={FontSizes[13]}
          fontWeight={600}
          color={CCColors?.Green}>
          Open Test
        </CCText>
      </TouchableOpacity>
      <TouchableOpacity
        onPress={onClose}
        style={styles.closeBtn}
        accessibilityLabel="Dismiss test banner"
        hitSlop={{top: 8, bottom: 8, left: 8, right: 8}}>
        <MaterialCommunityIcons
          name="close"
          size={20}
          color={CCColors?.White}
        />
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  banner: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    backgroundColor: CCColors?.Green,
    paddingHorizontal: 16,
    paddingVertical: 10,
    marginHorizontal: 12,
    marginTop: 8,
    borderRadius: 8,
  },
  textCol: {
    flex: 1,
    flexDirection: 'column',
  },
  openBtn: {
    backgroundColor: CCColors?.White,
    paddingHorizontal: 14,
    paddingVertical: 8,
    borderRadius: 6,
  },
  closeBtn: {
    padding: 4,
    marginLeft: 4,
  },
});
